import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {DOCUMENT} from "@angular/common";
import {WINDOW_REF_TOKEN} from "../../tokens";

@Injectable()
export class IntClipBoardService {

  copy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    @Inject(DOCUMENT) private readonly documentRef: Document,
    @Inject(WINDOW_REF_TOKEN) private readonly windowRef: Window
  ) { }

  copyToClipboard(text: string): Observable<boolean> {
    const navigator = this.windowRef.navigator;
    if(navigator.clipboard) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.copy$.next(true);
        })
        .catch(() => {
          this.copy$.next(false);
        })
    }else{
      this.fallbackCopyTextToClipboard(text);
    }
    return this.copy$;
  }
  fallbackCopyTextToClipboard(text: string) {
    const textArea = this.documentRef.createElement("textarea");
    textArea.value = text;
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    this.documentRef.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      const successful = this.documentRef.execCommand('copy');
      this.copy$.next(successful);
    } catch (err) {
      this.copy$.next(false);
    }
    this.documentRef.body.removeChild(textArea);
  }
}
